/**
 * Wally "Recently viewed" row on the product page. Markup and notes:
 * sections/wally-recently-viewed.liquid.
 *
 * Records this product's handle at the front of localStorage wally:viewed (newest first, 12
 * kept), then fetches the section rendered for each earlier product and moves the card out of
 * its <template> into the row. A few spares are fetched because sold-out products come back
 * without a card; a product that 404s (deleted or unpublished) is dropped from the list. The row
 * is unhidden only when at least one card arrives, so a first visit shows nothing.
 *
 * Cards are the same Horizon product card as You may also like, so the theme's own custom
 * elements (product-card, swatches, quick add) and assets/wally-saved.js (hearts, via its
 * MutationObserver) pick them up once they are in the page.
 */
(function () {
  'use strict';

  var KEY = 'wally:viewed';
  var KEEP = 12;
  var SPARE = 4;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, KEEP))); } catch (e) { /* private mode: no row, no harm */ }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  class WallyRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.wallyRvReady) return;
      this.dataset.wallyRvReady = '1';

      var handle = this.dataset.handle;
      var max = parseInt(this.dataset.max, 10) || 4;
      var sectionId = this.dataset.sectionId;
      var earlier = read().filter(function (h) { return h !== handle; });
      write([handle].concat(earlier));
      if (!earlier.length || !sectionId) return;

      var wanted = earlier.slice(0, max + SPARE);
      var list = this.querySelector('[data-wally-rv-list]');
      var self = this;

      Promise.all(wanted.map(function (h) {
        return fetch(root() + 'products/' + encodeURIComponent(h) + '?section_id=' + encodeURIComponent(sectionId))
          .then(function (r) { return r.status === 404 ? { gone: true } : r.ok ? r.text().then(function (t) { return { html: t }; }) : {}; })
          .catch(function () { return {}; });
      })).then(function (results) {
        var gone = [];
        var shown = 0;
        results.forEach(function (res, i) {
          if (res.gone) gone.push(wanted[i]);
          if (!res.html || shown >= max) return;
          var tpl = new DOMParser().parseFromString(res.html, 'text/html').querySelector('template[data-wally-rv-card]');
          if (!tpl) return;
          list.appendChild(document.importNode(tpl.content, true));
          shown++;
        });
        if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        if (shown) self.hidden = false;
      });
    }
  }

  if (!customElements.get('wally-recently-viewed')) customElements.define('wally-recently-viewed', WallyRecentlyViewed);
})();
